import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem("op_user");
    return u ? JSON.parse(u) : null;
  });
  const [onboarding, setOnboarding] = useState(null);
  const [loading, setLoading] = useState(true);

  const persist = (token, u) => {
    localStorage.setItem("op_token", token);
    localStorage.setItem("op_user", JSON.stringify(u));
    setUser(u);
  };

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setOnboarding(data.onboarding);
      localStorage.setItem("op_user", JSON.stringify(data.user));
    } catch (e) {
      // ignore
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("op_token")) refresh();
    else setLoading(false);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    persist(data.token, data.user);
    await refresh();
    return data;
  };

  const signup = async (name, email, password) => {
    const { data } = await api.post("/auth/signup", { name, email, password });
    persist(data.token, data.user);
    await refresh();
    return data;
  };

  const logout = () => {
    localStorage.removeItem("op_token");
    localStorage.removeItem("op_user");
    setUser(null);
    setOnboarding(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, onboarding, loading, login, signup, logout, refresh, setOnboarding }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
